<template>
	<section class="content">
		<form role="form" @submit.prevent="submitForm" class="card">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6 form-group">
						<label class="control-label">Tanggal Pembayaran</label>
						<datepicker v-model="form.tanggal" id="tanggal" name="tanggal" class="form-control" />
					</div>
					<div class="col-md-6 form-group">
						<label class="control-label">No. Invoice Pembayaran</label>
						<input type="text" v-model="form.invcode" id="invcode" name="invcode" class="form-control" placeholder="INV/15/12/2024" required />
					</div>
					<div class="col-md-4 form-group">
						<label class="control-label">Nama Rekan</label>
						<v-select :options="listRekan" :reduce="opt => opt.code" v-model="form.rekan" id="rekan" name="rekan" @search="searchRekan" placeholder="Pilih Rekan" required>
							<template v-slot:no-options="{ search, searching }">
								<template v-if="searching && search.length > 3">
									<em style="opacity: 0.5">Nama rekan {{ search }} tidak ditemukan.</em>
								</template>
								<em v-else style="opacity: 0.5">Ketik nama rekan</em>
							</template>
							<template #search="{attributes, events}">
								<input class="vs__search" v-bind="attributes" v-on="events" :required="!form.rekan" />
							</template>
						</v-select>
					</div>
					<div class="col-md-4 form-group">
						<label class="control-label">Bank Pembayaran</label>
						<select v-model="form.bank" id="bank" name="bank" class="form-control" required>
							<option :value="null" selected disabled hidden>Pilih Bank</option>
							<option v-for="bank in listBank" v-bind:key="bank.rekening_id" v-bind:value="bank.rekening_id">
								{{ bank.label }}
							</option>
						</select>
					</div>
					<div class="col-md-4 form-group">
						<label class="control-label">Jenis Pembayaran</label>
						<select v-model="form.scenario" id="scenario" name="scenario" class="form-control" required>
							<option :value="null" selected disabled hidden>Jenis Pembayaran</option>
							<option value="31">Ongkir</option>
							<option value="32">COD Fee</option>
						</select>
					</div>
					<div class="col-md-12 form-group">
						<label class="control-label">Upload File</label>
						<form action="/target" ref="dzone" class="dropzone card mb-0" style="border-style: dashed;">
							<div class="overlay" v-if="loading">
								<div class="spinner-border" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
							<div class="dz-message text-muted" data-dz-message><h4><div><i class="fa fa-upload"></i></div><span>Upload file Anda disini</span></h4></div>
						</form>
					</div>
				</div>
				<table class="table table-hover w-100" ref="tableRekons" :hidden="rekons_list.length < 1">
					<thead>
						<tr>
							<th>Total Hutang ongkir</th>
							<th>Total Hutang COD fee</th>
						</tr>
					</thead>
					<tbody></tbody>
				</table>
				<div class="row justify-content-end mt-3">
					<div class="col-12 col-sm-auto">
						<button type="button" class="btn btn-outline-primary" @click.prevent="downloadTemplate">
							<span v-if="loadingDownload && false" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							<i v-else-if="false" class="fi fi-rr-download"></i> Download Template
						</button>
					</div>
					<div class="col-12 col-sm-auto">
						<button type="submit" id="submit" class="btn btn-primary" :disabled="disabled">
							Upload Template
						</button>
					</div>
				</div>
			</div>
		</form>
	</section>
</template>
<script>
import { authFetch, createTable, formatRupiah } from '@/libs/hxcore';
import Dropzone from "dropzone";
import XLSX from "xlsx";
import Swal from 'sweetalert2';
import $ from 'jquery';
import "dropzone/dist/dropzone.css";
import datepicker from "@/components/Datepicker";
import moment from "moment";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
	name: 'FormRekonsHutang',
	data() {
		return {
			errors: [],
			roles: '',
			loading: false,
			loadingDownload: false,
			data: [],
			form: {
				tanggal: moment().format("DD/MM/YYYY"),
				invcode: null,
				rekan: null,
				bank: null,
				scenario: null,
			},
			formData: [],
			listRekan: [],
			listBank: [],
			rekons_list: [],
			disabled: false
		}
	},
	components: {
		datepicker,
		vSelect,
	},
	computed: {},
    watch: {
        disabled: function (val) {
			return this.form.tanggal === null || this.form.invcode === null || this.form.rekan === null || this.form.bank === null || this.form.scenario === null || this.listRekan.length < 1 || this.rekons_list.length < 1 || this.loading === true;
		}
	},
	created: function() {
		authFetch("/master/rekanan/search")
		.then((res) => {
			if (res.status === 201) {} else if (res.status === 400) {}
			return res.json();
		})
		.then((js) => {
			this.listRekan = js.data;
		});

		this.loadBank();
        $('.loading-overlay').removeClass('show');
	},
	methods: {
		loadBank: function () {
			authFetch("/payment/saldo/bank")
			.then((res) => {
				if (res.status === 201) {} else if (res.status === 400) {}
				return res.json();
			})
			.then((js) => {
				this.listBank = js.data;
			});
		},
		searchRekan: function(search, loading) {
			if (search.length >= 3 && this.loading === false) {
				loading(true);
				this.loading = true;

				authFetch(`/master/rekanan/search?search=${escape(search)}`)
				.then((res) => {
					if (res.status !== 200) {
						loading(false);
						this.loading = false;
					}
					return res.json();
				})
				.then((js) => {
					this.listRekan = js.data;
				});

				loading(false);
				this.loading = false;
			}
		},
		downloadTemplate: function()
		{
			this.loadingDownload = true;
			authFetch("/file/aset/template_hutang", {
				method: 'GET',
			})
			.then(response => response.blob())
			.then(blob => {
				this.loadingDownload = false;
				var url = window.URL.createObjectURL(blob);
				var a = document.createElement('a');
				a.href = url;
				a.download = "template_monitoring_hutang.xlsx";
				document.body.appendChild(a);
				a.click();	
				a.remove();
			});
		},
		excelImport(file) {
			const e = this.$refs;
			var input = file;
			if (this.table) {
				this.table.api().clear().draw();
			}
			var reader = new FileReader();
			reader.onload = () => {
				var fileData = reader.result;
				var wb = XLSX.read(fileData, { type: "binary" });
				var worksheet = wb.Sheets[wb.SheetNames[0]];
				var rowObj = XLSX.utils.sheet_to_json(worksheet);
				let data = rowObj;
				var key = [];
				for (var property in data[0]) {
					key.push(property);
				}

				if (key[0].trim() !== 'No AWB' ||
					key[1].trim() !== 'Total hutang' ||
					key[2].trim() !== 'Hutang ongkir' ||
					key[3].trim() !== 'Hutang COD fee' ||
					!data[0][key[0]] || !data[0][key[1]] || data[0][key[2]] <= 0 && data[0][key[3]] <= 0
				) {
					Swal.fire("Proses gagal", `data atau kolom tidak sesuai!<pre>` + key + `</pre>`, "error");
					this.loading = false;
				} else {
					this.formData = [];
					for (var i = 0; i < data.length; i++) {
						this.formData.push({
							no_resi: data[i][key[0]],
							total_hutang: data[i][key[1]],
							hutang_ongkir: data[i][key[2]],
							hutang_cod_fee: data[i][key[3]]
						});
					}

					this.rekons_list = [
						{
							total_hutang_ongkir: data.reduce((sum, item) => sum + (item[key[2]] || 0), 0),
							total_hutang_cod_fee: data.reduce((sum, item) => sum + (item[key[3]] || 0), 0)
						}
					];

					if (this.table) {
						this.table.fnAddData(this.rekons_list);
						this.loading = false;
					} else {
						const self = this;
						this.table = createTable(e.tableRekons, {
							data: self.rekons_list,
							serverSide: false,
							selectedRowClass: "",
							frame: false,
							displayLength: 100,
							lengthChange: false,
							filter: false,
							bSort: false,
							columns: [
								{
									data: "total_hutang_ongkir",
									render: function (data, type, row, meta) {
										return formatRupiah(data);
									}
								},
								{
									data: "total_hutang_cod_fee",
									render: function (data, type, row, meta) {
										return formatRupiah(data);
									}
								},
							],
							initComplete: function () {
								self.loading = false;
							}
						});
					}
				}
			};

			reader.readAsBinaryString(input);
		},
		submitForm: function (ev) {
			var self = this;
			const e = this.$refs;

			Swal.fire({
				title: "Simpan?",
				showCancelButton: true,
				confirmButtonText: `Ya`,
				cancelButtonText: "Tidak",
			}).then((result) => {
				if (result.isConfirmed) {
					authFetch("/report/hutang/rekonsiliasi", {
						method: "POST",
						headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
						},
						body: JSON.stringify({group: self.form, items: self.formData}),
					})
					.then((res) => {
						return res.json();
					})
					.then((js) => {
						if (js.success) {
							Swal.fire("Proses Berhasil", ``, "success");
							this.form = {
								tanggal: moment().format("DD/MM/YYYY"),
								invcode: null,
								rekan: null,
								bank: null,
								scenario: null,
							};
							this.formData = [];
							this.listRekan = [];
							this.rekons_list = [];
							this.loadBank();

							authFetch("/master/rekanan/search")
							.then((res) => {
								if (res.status === 201) {} else if (res.status === 400) {}
								return res.json();
							})
							.then((js) => {
								this.listRekan = js.data;
							});
						} else {
							Swal.fire("Proses gagal", ``, "error");
						}
					});
				}
			});

			ev.preventDefault();
		},
	},
	mounted() {
		const e = this.$refs;
		const self = this;

		Dropzone.autoDiscover = false;
		let myDropzone = new Dropzone(this.$refs.dzone, {
			uploadMultiple: false, maxFiles: 1, maxFilesize: 20,
			acceptedFiles: ".xls,.xlsx", createImageThumbnails: false,
			autoProcessQueue: false,
			url: 'getMeSomeUrl',
			accept: function(file, done) {
				this.removeFile(file);
			},
			success: function(file)
			{
				this.removeFile(file);
			}
		});

		myDropzone.on("addedfile", file => {
			this.loading = true;
			var input = file;
			this.excelImport(input);
		});

		myDropzone.on("maxfilesexceeded", function (file) {
			myDropzone.removeAllFiles();
		});
	}
}
</script>
<style scoped>
</style>